import React, { useEffect } from "react";
import "./GamificationActivityDialog.css";

const GamificationActivityDialog = ({ notice, onClose }) => {
  useEffect(() => {
    if (!notice) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [notice, onClose]);

  if (!notice) return null;
  return (
    <div className="gamification-activity-dialog__backdrop" onClick={onClose}>
      <div className="gamification-activity-dialog" role="dialog" aria-modal="true"
        aria-labelledby="gamification-activity-dialog-title" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="gamification-activity-dialog__close"
          aria-label="Close" onClick={onClose}>�</button>
        <h2 id="gamification-activity-dialog-title">{notice.title}</h2>
        <p>{notice.message}</p>
        <button type="button" className="gamification-activity-dialog__button"
          onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default GamificationActivityDialog;
